module.exports = __webpack_public_path__ + "static/media/prepTime.651d6633.svg";